import { cn } from "@/lib/utils"

interface TranslationLoaderProps {
  isEnglish: boolean
}

export default function TranslationLoader({
  isEnglish,
}: TranslationLoaderProps) {
  return (
    <div className="flex animate-pulse flex-col gap-1.5">
      <span
        className={cn(
          "text-xs font-medium tracking-wide uppercase",
          isEnglish
            ? "text-blue-100 dark:text-blue-200"
            : "text-slate-500 dark:text-slate-400",
        )}
      >
        Translation
      </span>
      <p
        className={cn(
          "text-sm leading-relaxed",
          isEnglish
            ? "text-blue-200 dark:text-blue-300"
            : "text-slate-400 dark:text-slate-500",
        )}
      >
        Generating translation...
      </p>
    </div>
  )
}
